module.exports = __webpack_public_path__ + "static/media/heart-off.bff886d5.png";